import { useEffect, useMemo, useRef } from 'react';
import { useActiveConversation } from '../../contexts/ActiveConversationContext';
import type { ContentBlock } from '../../types/api';
import { MessageBubble } from './MessageBubble';

export function MessageList() {
  const { messages, runState, pending } = useActiveConversation();
  const scrollerRef = useRef<HTMLDivElement>(null);

  const pendingBlocks = useMemo<ContentBlock[]>(() => {
    if (!pending) return [];
    return Object.keys(pending.blocks)
      .map(Number)
      .sort((a, b) => a - b)
      .map((i) => pending.blocks[i])
      .filter((b): b is ContentBlock => b !== undefined);
  }, [pending]);

  // Auto-scroll on new content.
  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollTop = el.scrollHeight;
  }, [messages, pendingBlocks, runState]);

  return (
    <div className="chat-messages" ref={scrollerRef}>
      {messages.map((msg) => (
        <MessageBubble key={msg.id} role={msg.role} blocks={msg.content} />
      ))}
      {(runState === 'sending' || runState === 'streaming') && (
        <MessageBubble
          role="assistant"
          blocks={pendingBlocks}
          streaming={pendingBlocks.length === 0}
        />
      )}
    </div>
  );
}
